import * as queries from 'lib/graphql/queries';
import { GraphQLClient } from 'types';
import { poll } from 'lib/poll';
import { RefundType } from 'lib/graphql';
import { SelfServiceAPI } from 'apis';

const acceptCancellationQuote = async (client: GraphQLClient, bookingId: string, cancellationId: string, refundType: RefundType) => {
  await queries.acceptCancellation(client, { variables: { bookingId, cancellationId, input: { refundType } } });

  const acceptedResult = await poll({
    requestFn: () => SelfServiceAPI.getCancellation({ bookingId, cancellationId }),
    isFinished: (result) => result.cancellation.state !== 'ACCEPTING',
  });

  if (!['ACCEPTED', 'FAILED', 'BLOCKED'].includes(acceptedResult.cancellation.state)) {
    throw Error(`Unexpected cancellation state "${acceptedResult.cancellation.state}"`);
  }

  return acceptedResult.cancellation;
};

export default acceptCancellationQuote;
